module.exports = __webpack_public_path__ + "static/media/workwear.cc9dee67.svg";